import { useQuery } from 'wasp/client/operations';
import { getClientFlags } from 'wasp/client/operations';

// Returns only boolean flags for UI gating to avoid type conflicts
export function useFlags(): Record<string, boolean> {
  const { data } = useQuery(getClientFlags, undefined, { staleTime: 60_000 });
  const base: Record<string, boolean> = { DEMO_DATA: false, ENABLE_STRIPE: true, ENABLE_LQS: true };
  const src = (data as any) || base;
  const bools: Record<string, boolean> = { ...base };
  for (const [k, v] of Object.entries(src)) {
    if (typeof v === 'boolean') bools[k] = v as boolean;
  }
  return bools;
}
